import { useEffect } from 'react';

import { useFormikContext } from 'formik';

import { ISignupForm } from 'utils/form/types';

const UpdateSessionStorage = () => {
  const { values } = useFormikContext<ISignupForm>();
  useEffect(() => {
    staticUserForm.current = values;
  }, [values]);
  return null;
};

export const staticUserForm: { current: ISignupForm | null } = { current: null };

export default UpdateSessionStorage;
